import { debugTelemetryService } from '@/shared/services/debugTelemetryService';

/**
 * Structured log categories for the adaptive-frame-pacing telemetry system.
 * Every category is a bracketed string literal so log output is grep-able.
 */
export type LogCategory =
  | '[QualityGate]'
  | '[PoseValidator]'
  | '[WaitForFrontal]'
  | '[LivenessChallenge]'
  | '[ScanPhase]'
  | '[InferEmbedding]'
  | '[StepTransition]';

/**
 * Emits a structured timing log gated by:
 *   - Always in DEV (`import.meta.env.DEV === true`)
 *   - In production only when the admin has enabled debug telemetry
 *     (`debugTelemetryService.getSync() === true`)
 *
 * Returns immediately (no-op) when the gate is closed — zero overhead in
 * production when the flag is off.
 */
export function logTiming(category: LogCategory, payload: object): void {
  // Gate is evaluated at call time, not at module init, so vi.stubEnv works.
  if (!import.meta.env.DEV && !debugTelemetryService.getSync()) return;
  // eslint-disable-next-line no-console -- intentional structured telemetry output
  console.log(category, payload);
}
